import { useMutation } from '@tanstack/react-query';
import { getAuthModule } from '../install';
export function useResendVerificationEmail() {
    return useMutation({
        mutationFn: () => getAuthModule().actions.resendEmailVerification(),
    });
}
